import Decimal from "decimal.js";

/**
 * Create a Decimal from a number or string for precise finance math.
 */
export function toDecimal(value: number | string): Decimal {
  return new Decimal(value);
}

/**
 * Round a Decimal to 2 decimal places (for currency).
 */
export function roundCurrency(value: Decimal): number {
  return value.toDecimalPlaces(2).toNumber();
}
